import * as reducersConfigurationAnonymous from 'app/factory-anonymous';
export const reducersConfiguration = reducersConfigurationAnonymous;
